import React from 'react';
import '../../styles/About.css';

export default function PrivacyPolicy() {
    return (
        <div className='privacy-page'>
            {/* Header Section */}
            <div className='privacy-hero'>
                <div className='privacy-hero-content'>
                    <h1 className='privacy-hero-title'>Privacy Policy</h1>
                    <p className='privacy-hero-subtitle'>Effective as of 1 January, 2026</p>
                </div>
            </div>

            {/* Content Section */}
            <div className='privacy-content'>
                <div className='privacy-section'>
                    <h2 className='privacy-section-title'>1. Information We Collect</h2>
                    <ul className='privacy-list'>
                        <li>When you engage with forms (e.g., contact, comments), we may collect your name, email, message, and related content.</li>
                        <li>We also collect technical data like your IP address and browser user agent, primarily for spam prevention and security purposes.</li>
                    </ul>
                </div>

                <div className='privacy-section'>
                    <h2 className='privacy-section-title'>2. How We Use Your Information</h2>
                    <ul className='privacy-list'>
                        <li>Your contact submissions are used solely to respond to your inquiries or manage requests you initiate.</li>
                        <li>Technical data helps us secure our site, detect spam, and improve user experience.</li>
                    </ul>
                </div>

                <div className='privacy-section'>
                    <h2 className='privacy-section-title'>3. Data Sharing</h2>
                    <ul className='privacy-list'>
                        <li>We do not sell or share your personal information with third parties, except where required by law.</li>
                    </ul>
                </div>

                <div className='privacy-section'>
                    <h2 className='privacy-section-title'>4. Cookies & Tracking</h2>
                    <ul className='privacy-list'>
                        <li>CANTO does not rely on tracking cookies or personal identifiers beyond what is needed for genuine engagement (e.g., form submissions).</li>
                        <li>If any tools or analytics are added in the future, we will provide clear notice and obtain your consent where required.</li>
                    </ul>
                </div>

                <div className='privacy-section'>
                    <h2 className='privacy-section-title'>5. Security</h2>
                    <ul className='privacy-list'>
                        <li>We take reasonable steps to keep your personal data safe.</li>
                        <li>However, given the nature of internet transmissions, we cannot guarantee 100% security.</li>
                    </ul>
                </div>

                <div className='privacy-section'>
                    <h2 className='privacy-section-title'>6. Your Rights</h2>
                    <p className='privacy-text'>Depending on your jurisdiction, you may have rights to:</p>
                    <ul className='privacy-list'>
                        <li>Access the data we hold about you</li>
                        <li>Request correction or deletion</li>
                        <li>Withdraw consent, if applicable</li>
                    </ul>
                    <p className='privacy-note'>Note: Since we collect minimal personal data, these rights typically apply to the content you've provided.</p>
                </div>

                <div className='privacy-section'>
                    <h2 className='privacy-section-title'>7. Policy Updates</h2>
                    <ul className='privacy-list'>
                        <li>We may update this policy over time. The current version will always be available here.</li>
                        <li>If changes meaningfully affect your rights or require consent, we will inform you explicitly.</li>
                    </ul>
                </div>

                <div className='privacy-section'>
                    <h2 className='privacy-section-title'>8. Contact Us</h2>
                    <p className='privacy-text'>If you have any questions or concerns about this policy, please email <a href='mailto:canto@canto.org' className='privacy-link'>canto@canto.org</a> or write to:</p>
                    <div className='privacy-address'>
                        <strong>CANTO Secretariat</strong><br />
                        67 Picton Street<br />
                        Port of Spain<br />
                        Trinidad & Tobago
                    </div>
                </div>
            </div>
        </div>
    );
}
